import React from "react"
import { useSelector, useDispatch } from "react-redux"

import { VIEW, DELETE } from "const"
import { MarkovModel } from "server/models"
import { hasAccess } from "client/utils"
import { markovModelsRoute } from "client/parts/routes"
import {
    PRM_MARKOV_MODEL,
    StoreType,
    addModal,
} from "client/store"
import {
    Link,
    DateFormatter,
    TableColumn,
    UserIcon,
} from "client/components"

const Columns = () => {
    const userList = useSelector((state: StoreType) => state.user.userList)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const deleteAccess = hasAccess(PRM_MARKOV_MODEL, DELETE)

    const columns: TableColumn[] = [
        {
            field: "id",
            header: lang.id,
            sortable: true,
        },
        {
            field: "name",
            header: lang.name,
            sortable: true,
            cellMinWidth: "100px",
            cellMaxWidth: "300px",
            formatter: (model: MarkovModel) => {
                const href = `${markovModelsRoute}/${VIEW}/${model.id}`
                return (
                    <Link
                        href={href}
                        onClick={() => dispatch(addModal({ url: href }))}
                    >
                        {model.name}
                    </Link>
                )
            },
        },
        {
            field: "description",
            header: lang.description,
            cellMinWidth: "200px",
            cellMaxWidth: "400px",
        },
        {
            field: "creator",
            header: lang.creator,
            cellMinWidth: "150px",
            formatter: (model: MarkovModel) => <UserIcon user={userList[model.creator]} size="sm" />,
        },
        {
            field: "createdAt",
            header: lang.created,
            sortable: true,
            formatter: (model: MarkovModel) => <DateFormatter date={model.createdAt} />,
        },
    ]

    if (deleteAccess) {
        columns.push({
            field: "delete",
            centerAlign: true,
            deleteAccess: () => true,
        })
    }

    return columns
}
export default Columns
